module.exports = __webpack_public_path__ + "static/0049-8d923b2ae0587b3d4760a66514da3f4b.png";